import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { useLinkingAttemptsContext } from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptsContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import { fullDateTime } from 'Consts/DateFormats';
import LinkingEventsMetaTable from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingEventsMetaTable';
import LinkingAttemptForm from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptForm';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    width: '100%',
  },
  fieldList: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  fieldListRow: {
    display: 'block',
    flex: 'none',
    marginRight: theme.spacing(2),
    width: '30%',
    overflow: 'hidden',
  },
  fieldListControl: {
    flexDirection: 'column',
    '& > label': {
      position: 'initial',
      marginBottom: '0px',
    },
    '& > div': {
      paddingTop: '0px',
    },
  },
});

export const getLinkingAttemptsTableFilters = (householdSearch, queryName) => [
  {
    name: 'householdId',
    overrideOptions: householdSearch ? householdSearch.map(search => ({
      name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
      value: search.id.toString(),
    })) : [],
    _setQueryParam: true,
    query: queryName,
  },
  {
    name: 'hasSupportTicket',
    query: queryName,
  },
  {
    name: 'isFailure',
    query: queryName,
  },
];

export const LinkingAttemptsBaseOverride = fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
    readonly: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .typeOverride('date', {
    _displayTime: true,
    _formatString: fullDateTime,
  });

const LinkingAttemptsContent = ({
  className,
  classes,
}) => {
  const { householdSearch } = useSimpleHousehold();
  const { linkingAttemptCollection } = useLinkingAttemptsContext();

  function handleExpanded(resource) {
    return (
      <React.Fragment>
        <LinkingAttemptForm resource={resource} />
        <LinkingEventsMetaTable resource={resource} />
      </React.Fragment>
    );
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaTable
        onExpanded={handleExpanded}
        collection={linkingAttemptCollection}
        isPageView
        tableMetaOverrideSetName="LinkingAttemptsBaseOverride"
        hasMetaQueryForm
        columns={[
          { name: 'timestamp', style: { maxWidth: '150px' } },
          { name: 'platform' },
          { name: 'providerName' },
          { name: 'status' },
          { name: 'additionalStatus' },
          { name: 'reason' },
        ]}
        QueryFormProps={{
          getAvailableFilters: () => linkingAttemptCollection.meta().query('getLinkingAttempts') && getLinkingAttemptsTableFilters(householdSearch, 'getLinkingAttempts'),
        }}
        hasSortableColumns
        linkQueryParamName={'getFeatureToggles'}
      />
    </Box>
  );
};

LinkingAttemptsContent.defaultProps = {
  className: '',
};

LinkingAttemptsContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkingAttemptsContent);
